import React, { useState, useEffect, useRef } from "react";
import * as JsSearch from "js-search";
import '../scss/components/_search-container.scss';
import _ from "lodash";

const Search = (props) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [categoriesQuery, setCategoriesQuery] = useState([]);
    const [menuCategoriesOpen, setMenuCategoriesOpen] = useState(false);
    const [firstClick, setFirstClick] = useState(false);
    const menuCategoriesRef = useRef(null);
    const menuCategoriesRefMobile = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if(window.innerWidth > 767) {
                if ((menuCategoriesRef.current && !menuCategoriesRef.current.contains(event.target))) {
                    setMenuCategoriesOpen(false);
                }
            } else {
                if ((menuCategoriesRefMobile.current && !menuCategoriesRefMobile.current.contains(event.target))) {
                    setMenuCategoriesOpen(false);
                }
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuCategoriesRef, menuCategoriesRefMobile]);


    useEffect(() => {
        props.searchQuery && setSearchQuery(props.searchQuery);
        let auxArray = [];
        typeof props.categoryQuery === "string" && auxArray.push(props.categoryQuery);
        props.categoryQuery && setCategoriesQuery(typeof props.categoryQuery === "object" ? props.categoryQuery : props.categoryQuery.split(','));
    }, [props.searchQuery, props.categoryQuery])

    const handleSubmit = e => {
        window.location.href = `/blog/search/?categories=${categoriesQuery}&query=${searchQuery}`;
        e.preventDefault()
    }

    const handleChange = value => {
        setSearchQuery(value);
        setMenuCategoriesOpen(true);
        setFirstClick(true);
    }

    const handleMenuCategories = () => {setMenuCategoriesOpen(!menuCategoriesOpen); setFirstClick(true);}

    const handleActiveCategoryItem = (e) => e.target.classList.toggle('search-bar-category-item-active');
    const handleCategoriesQuery = (category) => {
        categoriesQuery.some(c => c === category) ? setCategoriesQuery(categoriesQuery.filter(item => item !== category)) : setCategoriesQuery(categoriesQuery => [...categoriesQuery, category]);
    }

    return (
        <div className={`${!props.isMobile ? "search" : "search-mobile"} ${(menuCategoriesOpen && props.isMobile) ? "hideNavbar" : "showNavbar"}`}>
            <div className="search-bar">
                <div className={`${menuCategoriesOpen ? "onlyMobile" : "hide"} search-bar-header`}>
                    <img src="/icons/Icon-arrow-back.svg" />
                    <h1 className="search-bar-title">Blog</h1>
                </div>
                <h1 className={`${menuCategoriesOpen ? "hide" : "onlyMobile"} search-bar-title`}>Blog</h1>
                <h1 className="desktop search-bar-title">Blog</h1>
                <form className="search-bar-form" onSubmit={handleSubmit}>
                    <div className="search-bar-images-container">
                        <input
                            id="Search"
                            value={searchQuery}
                            onChange={e => { handleChange(e.target.value) }}
                            onClick={e => { handleChange(e.target.value) }}
                            className={`search-bar-form-input`}
                            autoComplete="off"
                            placeholder="Search..."
                        />
                        <img className="icon-search" src="/icons/icon-search.svg" />
                        <img src="/icons/icon-filter.svg" className={`${menuCategoriesOpen && "filter-active"} noMobile icon-filter`} onClick={handleMenuCategories}/>
                        <div ref={menuCategoriesRef} className={`${menuCategoriesOpen && firstClick ? "showCategories" : "hideCategories"} noMobile search-bar-category-list ${firstClick ? "showCategoriesLoading" : "hideCategoriesLoading"}`} >
                            <div className="search-bar-category-border">
                                <div className="search-bar-category-text">
                                    <span>Filter by categories: </span>
                                </div>
                                <div className="search-bar-category-list-container">
                                    {!_.isEmpty(props.categories) && props.categories.map(category => {
                                            const isSelected = categoriesQuery.includes(category);

                                            return (<a className={`search-bar-category-item ${isSelected && "search-bar-category-item-active"}`} onClick={e => { handleActiveCategoryItem(e); handleCategoriesQuery(category) }}>{category}</a>)
                                    })}
                                </div>
                            </div>
                        </div>

                        <div ref={menuCategoriesRefMobile} className={`${menuCategoriesOpen && firstClick ? "showCategories" : "hideCategories"} search-bar-category-list onlyMobile ${firstClick ? "showCategoriesLoading" : "hideCategoriesLoading"}`} >
                            <div className="search-bar-category-border">
                                <div className="search-bar-category-text">
                                    <span>Filter by categories: </span>
                                </div>
                                <div className="search-bar-category-list-container">
                                    {!_.isEmpty(props.categories) && props.categories.map(category => {
                                            const isSelected = categoriesQuery.includes(category);
                                            
                                            return (<a className={`mobiletag search-bar-category-item ${isSelected && "search-bar-category-item-active"}`} onClick={e => { handleActiveCategoryItem(e); handleCategoriesQuery(category) }}>{category}</a>)
                                    })}
                                    <div className="search-bar-category-button">
                                        <button type="submit" className="onlyMobile search-bar-form-submit">SEARCH</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button type="submit" className="noMobile search-bar-form-submit">SEARCH</button>
                </form>
            </div>
        </div>
    )
}
export default Search